export const MediaHelper = {
    isEqualMedias(firstItem, secondItem) {
        if (!firstItem || !secondItem)
            return false;
        if (firstItem.length !== secondItem.length)
            return false;
        return firstItem.every((item, index) => {
            const other = secondItem[index];
            return (item.id === other.id &&
                item.fileSignedUrl === other.fileSignedUrl &&
                item.fileOrder === other.fileOrder &&
                item.playerMedia?.duration === other.playerMedia?.duration &&
                item.playerMedia?.status === other.playerMedia?.status &&
                item.size === other.size);
        });
    }
};
